module.exports = __webpack_public_path__ + "media/images/menu/gilmec_back-a73d31efba067580554c86abe1ec31eb.jpg";